module.exports = __webpack_public_path__ + "static/media/export-csv-dafault.2117a438.svg";


//////////////////
// WEBPACK FOOTER
// ./public/images/export-csv-dafault.svg
// module id = 1304
// module chunks = 1